<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { filters } from '@/utility/deviceFiltering'
import VIDToDevice from '@/utility/VIDTODevice';
import Vue from 'vue'
export default {
  name: 'App',
  data() {
    return {
      device: null,
      isShowConfirm: false
    }
  },
  beforeCreate() {
    this.$router.push('/')
  },
  created() {
    this.getLan()
    Vue.prototype.g_sys = this.getExplore()
    window.addEventListener('languagechange', () => {
      location.reload()
    })
  },
  components: {
    // curveBox,
    // csBox
    // keyboard_KG698U
  },
  mounted() {
    if (navigator.hid) {
      navigator.hid.onconnect = this.deviceConnect
      navigator.hid.ondisconnect = this.deviceDisConnect
    }
  },
  methods: {
    // 检测浏览器版本信息
    getExplore() {
      if (navigator.hid) return true
      // let sys = '';
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/edge\/([\d.]+)/)) {
        this.$message.error(this.$t('h.browserVersionTips', { n: 'Edge' }))
        // sys = ua.match(/edge\/([\d.]+)/)[1].split('.')[0]
        // if (sys < 89 || !navigator.hid) {
        //   this.$message.error('当前Edge浏览器版本过低，请升级到最新版本！')
        //   return false
        // }
        // return true
      } else if (ua.match(/(?:opera|opr).([\d.]+)/)) {
        this.$message.error(this.$t('h.browserVersionTips', { n: 'Opera' }))
        // sys = ua.match(/(?:opera|opr).([\d.]+)/)[1].split('.')[0]
        // if (sys < 75 || !navigator.hid) {
        //   this.$message.error('当前Opera浏览器版本过低，请升级到最新版本！')
        //   return false
        // }
        // return true
      } else if (ua.match(/chrome\/([\d.]+)/)) {
        this.$message.error(this.$t('h.browserVersionTips', { n: 'Chrome' }))
        // sys = ua.match(/chrome\/([\d.]+)/)[1].split('.')[0]
        // if (sys < 89 || !navigator.hid) {
        //   this.$message.error('当前Chrome浏览器版本过低，请升级到最新版本！')
        //   return false
        // }
        // return true
      } else {
        this.$message.error(this.$t('h.browserVersionTips2'))
      }
      return false
    },
    getLan() {
      let lan = navigator.language
      if (lan.includes('zh')) {
        this.$i18n.locale = 'zh'
      } else {
        this.$i18n.locale = 'en'
      }
    },
    async deviceConnect(e) {
      if (this.$store.state.device) return
      // 判断当前连接HID设备的弹窗是否打开，如果打开了返回
      if (this.$store.state.isFindHIDStatus) return
      if (e.device.collections.length !== 1) return
      const hasDevice = filters.some(item => item.vendorId === e.device.vendorId
        && item.productId === e.device.productId
        && item.usagePage === e.device.collections[0].usagePage
        && item.usage === e.device.collections[0].usage)
      if (!hasDevice) return
      if (this.isShowConfirm) this.closeConfirm()
      let res = false
      try {
        this.isShowConfirm = {
          VID: e.device.vendorId,
          PID: e.device.productId
        }
        res = await this.$confirm(this.$t('h.reconnectedTipsTitle'), this.$t('h.reconnectedTipsHead'), {
          confirmButtonText: this.$t('h.sure'),
          cancelButtonText: this.$t('h.cancel'),
          type: 'success'
        })
      } catch (error) {
        this.isShowConfirm = null
        return
      }
      this.isShowConfirm = null
      if (!res) return
      this.device = e.device
      if (!this.device.opened) {
        await this.device.open()
      }
      this.$store.commit('setDevices', this.device)
      const vid = this.device.vendorId
      if (VIDToDevice.has(vid)) {
        let route = VIDToDevice.get(vid)
        if (this.$route.path !== '/' + route) {
          this.$router.replace({
            path: route
          })
        } else {
          this.$router.push('/kong')
        }
      }
    },
    async deviceDisConnect(e) {
      if (this.isShowConfirm && e.device.vendorId === this.isShowConfirm.VID && e.device.productId === this.isShowConfirm.PID) {
        this.closeConfirm()
        this.isShowConfirm = null
      }
      if (this.$route.path === '/') return
      if (!this.$store.state.device) return
      if (e.device.vendorId !== this.$store.state.device?.vendorId || e.device.productId !== this.$store.state.device?.productId) {
        return
      }
      this.$message.error(this.$t('h.disconnect'))
      this.device = null
      this.$router.push('/')
    },
    closeConfirm() {
      const btns = document.querySelectorAll('.el-message-box__btns')
      for (const btn of btns) {
        // 模拟取消按钮被点击
        btn.childNodes[0].click()
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  user-select: none;
  // background-color: #000;
}
</style>
